/**
 * Stytch Configuration
 * Centralizes all Stytch-related configuration
 */

export const stytchConfig = {
  projectId: import.meta.env.VITE_STYTCH_PROJECT_ID || '',
  publicToken: import.meta.env.VITE_STYTCH_PUBLIC_TOKEN || '',
  projectDomain: import.meta.env.VITE_STYTCH_PROJECT_DOMAIN || '',
  
  // Authentication settings
  sessionOptions: {
    sessionDurationMinutes: 60 * 8, // 8 hours (within 24-hour limit)
    sessionCookieOptions: {
      domain: window.location.hostname,
      secure: window.location.protocol === 'https:',
      sameSite: 'lax' as const,
    },
  },
  
  // Magic link settings
  magicLinkOptions: {
    loginMagicLinkURL: `${window.location.origin}/auth/magic-link`,
    signupMagicLinkURL: `${window.location.origin}/auth/magic-link`,
    loginExpirationMinutes: 30,
    signupExpirationMinutes: 30,
  },
  
  // Password settings
  passwordOptions: {
    strengthCheckOnEntry: true,
    resetPasswordURL: `${window.location.origin}/auth/reset-password`,
    resetPasswordExpirationMinutes: 30,
  },
};

// Validate configuration
export function validateStytchConfig(): boolean {
  const required = ['projectId', 'publicToken'];
  const missing = required.filter(key => !stytchConfig[key as keyof typeof stytchConfig]);
  
  if (missing.length > 0) {
    // Only log warning if environment variables are expected but empty
    // Silent when intentionally disabled (commented out in .env)
    return false;
  }
  
  return true;
}